import { render, staticRenderFns } from "./StudentSessionsSelectbox.vue?vue&type=template&id=60b4805e&"
import script from "./StudentSessionsSelectbox.vue?vue&type=script&lang=js&"
export * from "./StudentSessionsSelectbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports